export * from './InfoRectangle'
